import type { AgreementType } from '@portal/flows/domain/sa/types';

/**
 * The three service-agreement sales types — nybil, brugtbil, forlængelse — are three sidebar
 * sections of their own (the backend's `layout.schema.ts`), each with its own overview, price
 * list, customer list and orders page, addressed by the type's slug. The paths here must match
 * the routes in that schema.
 */
export const AGREEMENT_SECTION_SLUG = {
  NEW_CAR: 'new-car',
  USED_CAR: 'used-car',
  PROLONGING: 'prolonging',
} as const;
export type AgreementSectionType = keyof typeof AGREEMENT_SECTION_SLUG;
export const AGREEMENT_SECTION_TYPES = Object.keys(
  AGREEMENT_SECTION_SLUG,
) as readonly AgreementSectionType[];

export function agreementSectionFromSlug(slug: string): AgreementSectionType | null {
  const match = Object.entries(AGREEMENT_SECTION_SLUG).find(([, value]) => value === slug);
  return match ? (match[0] as AgreementSectionType) : null;
}

export type AgreementSectionPage = 'overview' | 'offers' | 'customers' | 'orders';

const PAGE_BASE: Record<AgreementSectionPage, string> = {
  overview: '/overview/service-agreement',
  offers: '/vehicle-service-offers',
  customers: '/service-agreement/customers',
  orders: '/service-agreement/orders',
};

/**
 * A type's page; the first type's for none, or for a type with no section of its own
 * (`KM_CATCH_UP` is not one of the three sales types).
 */
export function agreementSectionPath(
  page: AgreementSectionPage,
  type: AgreementType | undefined,
): string {
  const section = AGREEMENT_SECTION_TYPES.includes(type as AgreementSectionType)
    ? (type as AgreementSectionType)
    : 'NEW_CAR';
  return `${PAGE_BASE[page]}/${AGREEMENT_SECTION_SLUG[section]}`;
}
